import { fromJS } from 'immutable';

import { SHOW_MODAL_CONTROLLER, CLOSE_MODAL_CONTROLLER } from './constants';

const initialState = fromJS({
  showModalController: null,
  modalProps: null,
});

// Reducer implemented under global reducer in containers/App

function modalControllerReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_MODAL_CONTROLLER:
      return state
        .set('showModalController', action.modalType)
        .set('modalProps', action.props);
    case CLOSE_MODAL_CONTROLLER:
      return state.set('showModalController', null).set('modalProps', null);
    default:
      return state;
  }
}

export default modalControllerReducer;
